import {ITracking} from 'api/transactions';
import {
    PAYOUT_PUBLIC_SWIFT_TRACKING_CACHE,
    PAYOUT_PUBLIC_TRACKING_CACHE,
} from 'constants/cache';
import {useClient} from 'context/auth-context';
import {useQuery} from '@tanstack/react-query';
import {PayoutTracking} from 'types/api/payout-tracking';

const useGetPayoutTracking = (hash: string) => {
    const client = useClient();

    return useQuery<PayoutTracking>({
        queryKey: [PAYOUT_PUBLIC_TRACKING_CACHE, {hash}],
        queryFn: () => client(`/web_api/payout_tracking_public/${hash}`, {}),
    });
};

const useGetPayoutSwiftTracking = (hash: string, enabled: boolean) => {
    const client = useClient();

    return useQuery<ITracking>({
        queryKey: [PAYOUT_PUBLIC_SWIFT_TRACKING_CACHE, {hash}],
        queryFn: () =>
            client(`/web_api/payout_tracking_public/${hash}/swift`, {}),
        enabled,
    });
};

export {useGetPayoutTracking, useGetPayoutSwiftTracking};
